/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows = FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions);
    }

    return {};
}

